module.exports = {
  "country": "IT",
  "artist": "Domenico Modugno",
  "song": "Nel blu dipinto di blu (Volare)",
  "year": "1958",
  "place": "3",
  "spotify": "1deGaiuaHTt3mIlSL7fXoh"
};